import React, { Component } from 'react'
import './stepidentifier.scss'

class StepIdentifier extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		let classes = ['vbui--stepidentifier', this.props.classes].join(' ')
		let secondStep = ['step section2', this.props.step >= 2 ? 'step-active' : ''].join(' ')
		let secondLine = ['line', this.props.step >= 2 ? 'line-active' : ''].join(' ')
		let thirdStep = ['step section3', this.props.step >= 3 ? 'step-active' : ''].join(' ')
		let thirdLine = ['line', this.props.step >= 3 ? 'line-active' : ''].join(' ')
		return (
			<div className={classes}>
				<div className="step section1 step-active">
					{this.props.click1 && (
						<button className="invisible-button" onClick={this.props.click1}>
							<span>1</span>
							{this.props.text1}
						</button>
					)}
					{!this.props.click1 && (
						<div className="invisible-button">
							<span>1</span>
							{this.props.text1}
						</div>
					)}
				</div>
				<div className={secondLine}></div>
				{this.props.text2 && (
					<div className={secondStep}>
						{this.props.click2 && (
							<button className="invisible-button" disabled={this.props.step < 2} onClick={this.props.click2}>
								<span>2</span>
								{this.props.text2}
							</button>
						)}
						{!this.props.click2 && (
							<div className="invisible-button" disabled={this.props.step < 2}>
								<span>2</span>
								{this.props.text2}
							</div>
						)}
					</div>
				)}
				{this.props.text3 && (
					<React.Fragment>
						<div className={thirdLine}></div>
						<div className={thirdStep}>
							{this.props.click3 && (
								<button className="invisible-button" onClick={this.props.click3}>
									<span>3</span>
									{this.props.text3}
								</button>
							)}
							{!this.props.click3 && (
								<div className="invisible-button">
									<span>3</span>
									{this.props.text3}
								</div>
							)}
						</div>
					</React.Fragment>
				)}
			</div>
		)
	}
}

export default StepIdentifier
